import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  router = inject(Router);
  route = inject(ActivatedRoute);

  navigateToContent() {
    const route: string = localStorage.getItem('redirectUrl') || '/';
    void this.router.navigateByUrl(route);
  }
}
